module.exports = __webpack_public_path__ + "static/img/yytx.edc574b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/mother/yytx.png
// module id = 8Ia4
// module chunks = 1